import { IApp } from '../types/app';

export const installContextPluginSchema = async (): Promise<any> => {
    return true;
}

export const uninstallContextPluginSchema = async (): Promise<any> => {
    return true;
}

export const loadApp = (): IApp => ({
    configuredExpanded: true,
    schemaInstalled: true,
})



// WEBPACK FOOTER //
// ./src/sub-projects/radario/services/app.ts